import React, { useState, useEffect, useRef, useCallback } from 'react';
import api from '../../services/api';

const styles = {
  container: {
    display: 'flex',
    height: 'calc(100vh - 64px)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    backgroundColor: '#f5f5f5'
  },
  leftPanel: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    borderRight: '1px solid #e0e0e0',
    backgroundColor: '#ffffff'
  },
  rightPanel: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fafafa',
    overflow: 'hidden'
  },
  panelHeader: {
    padding: '16px 20px',
    borderBottom: '1px solid #e0e0e0',
    backgroundColor: '#ffffff'
  },
  panelTitle: {
    margin: 0,
    fontSize: '16px',
    fontWeight: 600,
    color: '#1a1a2e'
  },
  panelSubtitle: {
    margin: '4px 0 0 0',
    fontSize: '13px',
    color: '#666'
  },
  messagesContainer: {
    flex: 1,
    overflowY: 'auto',
    padding: '16px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  messageBubbleAdmin: {
    alignSelf: 'flex-end',
    maxWidth: '80%',
    padding: '10px 14px',
    borderRadius: '16px 16px 4px 16px',
    backgroundColor: '#1a1a2e',
    color: '#ffffff',
    fontSize: '14px',
    lineHeight: '1.5',
    wordWrap: 'break-word'
  },
  messageBubbleWizard: {
    alignSelf: 'flex-start',
    maxWidth: '80%',
    padding: '10px 14px',
    borderRadius: '16px 16px 16px 4px',
    backgroundColor: '#f0f0f0',
    color: '#333333',
    fontSize: '14px',
    lineHeight: '1.5',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap'
  },
  messageBubbleSystem: {
    alignSelf: 'center',
    maxWidth: '90%',
    padding: '8px 16px',
    borderRadius: '8px',
    backgroundColor: '#e3f2fd',
    color: '#1565c0',
    fontSize: '12px',
    fontWeight: 500,
    textAlign: 'center'
  },
  inputContainer: {
    padding: '12px 20px',
    borderTop: '1px solid #e0e0e0',
    backgroundColor: '#ffffff',
    display: 'flex',
    gap: '8px',
    alignItems: 'flex-end'
  },
  textInput: {
    flex: 1,
    padding: '10px 14px',
    borderRadius: '8px',
    border: '1px solid #d0d0d0',
    fontSize: '14px',
    fontFamily: 'inherit',
    resize: 'none',
    outline: 'none',
    minHeight: '40px',
    maxHeight: '120px'
  },
  sendButton: {
    padding: '10px 20px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#1a1a2e',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    opacity: 1
  },
  sendButtonDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed'
  },
  configPreview: {
    flex: 1,
    overflowY: 'auto',
    padding: '16px 20px'
  },
  configSection: {
    marginBottom: '16px',
    padding: '12px 16px',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0'
  },
  configSectionTitle: {
    margin: '0 0 8px 0',
    fontSize: '14px',
    fontWeight: 600,
    color: '#1a1a2e',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  configCode: {
    margin: 0,
    padding: '8px',
    borderRadius: '4px',
    backgroundColor: '#f8f8f8',
    fontFamily: '"SF Mono", "Fira Code", "Fira Mono", Menlo, monospace',
    fontSize: '12px',
    lineHeight: '1.5',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    color: '#333',
    border: '1px solid #eee',
    maxHeight: '300px',
    overflowY: 'auto'
  },
  actionButtonsContainer: {
    padding: '12px 20px',
    borderTop: '1px solid #e0e0e0',
    backgroundColor: '#ffffff',
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end'
  },
  validateButton: {
    padding: '8px 16px',
    borderRadius: '6px',
    border: '1px solid #1a1a2e',
    backgroundColor: '#ffffff',
    color: '#1a1a2e',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer'
  },
  applyButton: {
    padding: '8px 16px',
    borderRadius: '6px',
    border: 'none',
    backgroundColor: '#2e7d32',
    color: '#ffffff',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer'
  },
  applyButtonDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed'
  },
  validationResults: {
    padding: '12px 16px',
    borderRadius: '8px',
    marginBottom: '16px'
  },
  validationSuccess: {
    backgroundColor: '#e8f5e9',
    border: '1px solid #a5d6a7'
  },
  validationError: {
    backgroundColor: '#ffebee',
    border: '1px solid #ef9a9a'
  },
  validationWarning: {
    backgroundColor: '#fff3e0',
    border: '1px solid #ffcc80'
  },
  validationTitle: {
    margin: '0 0 6px 0',
    fontSize: '13px',
    fontWeight: 600
  },
  validationItem: {
    margin: '2px 0',
    fontSize: '12px',
    lineHeight: '1.4'
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    color: '#999',
    textAlign: 'center',
    padding: '40px'
  },
  emptyStateIcon: {
    fontSize: '48px',
    marginBottom: '16px',
    opacity: 0.3
  },
  emptyStateText: {
    fontSize: '14px',
    lineHeight: '1.5'
  },
  loadingDots: {
    display: 'inline-block',
    fontSize: '14px',
    color: '#666'
  },
  statusBadge: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: '11px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginLeft: '8px'
  },
  statusActive: {
    backgroundColor: '#e3f2fd',
    color: '#1565c0'
  },
  statusDraftReady: {
    backgroundColor: '#fff3e0',
    color: '#e65100'
  },
  statusValidated: {
    backgroundColor: '#e8f5e9',
    color: '#2e7d32'
  },
  statusApplied: {
    backgroundColor: '#e8f5e9',
    color: '#1b5e20'
  },
  appliedBanner: {
    padding: '12px 16px',
    borderRadius: '8px',
    backgroundColor: '#e8f5e9',
    border: '1px solid #a5d6a7',
    marginBottom: '16px',
    fontSize: '13px',
    color: '#2e7d32',
    fontWeight: 500
  },
  // Mode selector styles
  modeSelector: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '40px',
    gap: '24px'
  },
  modeSelectorTitle: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#1a1a2e',
    marginBottom: '4px'
  },
  modeSelectorSubtitle: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '16px'
  },
  modeCardsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
    maxWidth: '600px',
    width: '100%'
  },
  modeCard: {
    padding: '20px',
    borderRadius: '12px',
    border: '2px solid #e0e0e0',
    backgroundColor: '#ffffff',
    cursor: 'pointer',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    textAlign: 'left'
  },
  modeCardHover: {
    borderColor: '#1a1a2e',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
  },
  modeCardTitle: {
    fontSize: '15px',
    fontWeight: 600,
    color: '#1a1a2e',
    marginBottom: '6px'
  },
  modeCardDescription: {
    fontSize: '13px',
    color: '#666',
    lineHeight: '1.4'
  },
  // Source picker styles
  sourcePickerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '40px',
    gap: '16px'
  },
  sourcePickerTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#1a1a2e'
  },
  sourceSelect: {
    width: '100%',
    maxWidth: '500px',
    padding: '10px 14px',
    borderRadius: '8px',
    border: '1px solid #d0d0d0',
    fontSize: '14px',
    fontFamily: 'inherit',
    backgroundColor: '#ffffff'
  },
  sourcePickerActions: {
    display: 'flex',
    gap: '8px',
    marginTop: '8px'
  },
  backButton: {
    padding: '8px 16px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    backgroundColor: '#ffffff',
    color: '#666',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer'
  },
  continueButton: {
    padding: '8px 16px',
    borderRadius: '6px',
    border: 'none',
    backgroundColor: '#1a1a2e',
    color: '#ffffff',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer'
  },
  // Tab styles for right panel
  tabsContainer: {
    display: 'flex',
    borderBottom: '1px solid #e0e0e0',
    backgroundColor: '#ffffff'
  },
  tab: {
    padding: '10px 20px',
    fontSize: '13px',
    fontWeight: 500,
    color: '#666',
    cursor: 'pointer',
    border: 'none',
    borderBottom: '2px solid transparent',
    backgroundColor: 'transparent'
  },
  tabActive: {
    color: '#1a1a2e',
    borderBottomColor: '#1a1a2e'
  },
  // Change log styles
  changeLogEntry: {
    padding: '10px 14px',
    borderRadius: '6px',
    backgroundColor: '#ffffff',
    border: '1px solid #e8e8e8',
    marginBottom: '8px',
    fontSize: '13px'
  },
  changeLogAction: {
    fontWeight: 600,
    color: '#1a1a2e',
    marginBottom: '2px'
  },
  changeLogSummary: {
    color: '#555',
    lineHeight: '1.4'
  },
  changeLogTime: {
    fontSize: '11px',
    color: '#999',
    marginTop: '4px'
  },
  changeLogDiff: {
    marginTop: '8px',
    padding: '8px',
    borderRadius: '4px',
    backgroundColor: '#f8f8f8',
    border: '1px solid #eee',
    fontSize: '11px',
    fontFamily: 'monospace',
    maxHeight: '200px',
    overflowY: 'auto',
    whiteSpace: 'pre-wrap'
  },
  // Task history styles
  taskHistoryItem: {
    padding: '12px 16px',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0',
    marginBottom: '12px',
    cursor: 'pointer'
  },
  taskHistoryHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px'
  },
  taskHistoryMode: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '11px',
    fontWeight: 600,
    textTransform: 'uppercase'
  },
  newTaskButton: {
    padding: '10px 20px',
    borderRadius: '8px',
    border: '2px solid #1a1a2e',
    backgroundColor: '#ffffff',
    color: '#1a1a2e',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    textAlign: 'center'
  },
  taskBoundary: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 0',
    gap: '8px'
  },
  taskBoundaryLine: {
    flex: 1,
    height: '1px',
    backgroundColor: '#d0d0d0'
  },
  taskBoundaryLabel: {
    fontSize: '11px',
    color: '#999',
    fontWeight: 600,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
  },
  // Context bar styles
  contextBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px 20px',
    borderBottom: '1px solid #e0e0e0',
    backgroundColor: '#fafafa',
    fontSize: '13px',
    color: '#555',
    overflow: 'hidden',
    minWidth: 0
  },
  contextDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    flexShrink: 0
  },
  contextModeName: {
    fontWeight: 600,
    fontSize: '13px',
    flexShrink: 0
  },
  contextSeparator: {
    color: '#ccc',
    fontSize: '12px',
    flexShrink: 0
  },
  contextSourceName: {
    fontSize: '13px',
    color: '#333',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    flex: 1
  },
  contextTaskNumber: {
    marginLeft: 'auto',
    fontSize: '11px',
    fontWeight: 600,
    color: '#999',
    flexShrink: 0
  },
  // Inline source picker styles
  inlineSourcePicker: {
    padding: '12px 20px',
    borderTop: '1px solid #e0e0e0',
    backgroundColor: '#f8f9fa'
  },
  inlineSourcePickerHeader: {
    fontSize: '13px',
    fontWeight: 500,
    color: '#333',
    marginBottom: '8px'
  },
  inlineSourcePickerSelect: {
    width: '100%',
    padding: '8px 12px',
    borderRadius: '6px',
    border: '1px solid #d0d0d0',
    fontSize: '13px',
    fontFamily: 'inherit',
    backgroundColor: '#ffffff',
    marginBottom: '8px'
  },
  inlineSourcePickerActions: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end'
  },
  // Continuation hint after apply
  continuationHint: {
    padding: '8px 20px',
    fontSize: '12px',
    color: '#2e7d32',
    backgroundColor: '#f1f8e9',
    borderTop: '1px solid #c5e1a5',
    textAlign: 'center'
  }
};

const MODE_INFO = {
  create: { title: 'Create New', description: 'Build a new onboarding pipeline from scratch' },
  clone: { title: 'Clone & Modify', description: 'Copy an existing flow and make changes to the copy' },
  edit: { title: 'Edit Existing', description: 'Modify an existing configuration in place' },
  validate: { title: 'Validate & Troubleshoot', description: 'Check an existing config for issues and fix them' }
};

function getStatusStyle(status) {
  switch (status) {
    case 'active': return styles.statusActive;
    case 'draft_ready': return styles.statusDraftReady;
    case 'validated': return styles.statusValidated;
    case 'applied': return styles.statusApplied;
    default: return {};
  }
}

function getModeColor(mode) {
  switch (mode) {
    case 'create': return { backgroundColor: '#e3f2fd', color: '#1565c0' };
    case 'clone': return { backgroundColor: '#f3e5f5', color: '#7b1fa2' };
    case 'edit': return { backgroundColor: '#fff3e0', color: '#e65100' };
    case 'validate': return { backgroundColor: '#e8f5e9', color: '#2e7d32' };
    default: return {};
  }
}

function getModeDotColor(mode) {
  switch (mode) {
    case 'create': return '#1565c0';
    case 'clone': return '#7b1fa2';
    case 'edit': return '#e65100';
    case 'validate': return '#2e7d32';
    default: return '#999';
  }
}

function SetupWizard() {
  // Phase: 'mode_select' | 'source_select' | 'chat'
  const [phase, setPhase] = useState('mode_select');
  const [selectedMode, setSelectedMode] = useState(null);

  // Source picker
  const [availableSources, setAvailableSources] = useState(null);
  const [selectedFlowId, setSelectedFlowId] = useState('');
  const [selectedStrategyId, setSelectedStrategyId] = useState('');
  const [selectedPersonaId, setSelectedPersonaId] = useState('');
  const [selectedRuleId, setSelectedRuleId] = useState('');
  const [isLoadingSources, setIsLoadingSources] = useState(false);

  // Chat state
  const [sessionId, setSessionId] = useState(null);
  const [sessionStatus, setSessionStatus] = useState('active');
  const [sessionMode, setSessionMode] = useState('create');
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isCreatingSession, setIsCreatingSession] = useState(false);
  const [draftConfig, setDraftConfig] = useState(null);
  const [validationResults, setValidationResults] = useState(null);
  const [isValidating, setIsValidating] = useState(false);
  const [isApplying, setIsApplying] = useState(false);
  const [appliedConfig, setAppliedConfig] = useState(null);
  const [error, setError] = useState(null);

  // Context bar
  const [sourceName, setSourceName] = useState('New Pipeline');
  const [currentTaskIndex, setCurrentTaskIndex] = useState(0);

  // Inline source picker (for conversational transitions with ambiguous source)
  const [inlineSourcePicker, setInlineSourcePicker] = useState(null);
  // shape: { mode, availableSources: { flows, strategies, personas, rules } }
  const [inlineSelectedFlowId, setInlineSelectedFlowId] = useState('');
  const [inlineSelectedStrategyId, setInlineSelectedStrategyId] = useState('');

  // Right panel tab
  const [activeTab, setActiveTab] = useState('config'); // 'config' | 'changelog' | 'tasks'
  const [changeLog, setChangeLog] = useState([]);
  const [taskHistory, setTaskHistory] = useState([]);
  const [expandedTask, setExpandedTask] = useState(null);

  const messagesEndRef = useRef(null);
  const textareaRef = useRef(null);

  // Scroll to bottom when messages change
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  // Load available sources when entering source select phase
  const loadSources = useCallback(async () => {
    try {
      setIsLoadingSources(true);
      const response = await api.get('/admin/setup-wizard/available-sources');
      if (response.data.success) {
        setAvailableSources(response.data.sources);
      }
    } catch (err) {
      console.error('Error loading sources:', err);
      setError('Failed to load available configurations');
    } finally {
      setIsLoadingSources(false);
    }
  }, []);

  const handleModeSelect = (mode) => {
    setSelectedMode(mode);
    if (mode === 'create') {
      // Skip source picker, go straight to session creation
      createSession(mode);
    } else {
      setPhase('source_select');
      loadSources();
    }
  };

  const createSession = async (mode, sourceFlowId, sourceStrategyId, sourcePersonaId, sourceRuleId) => {
    try {
      setIsCreatingSession(true);
      setError(null);

      const body = { mode };
      if (sourceFlowId) body.sourceFlowId = sourceFlowId;
      if (sourceStrategyId) body.sourceStrategyId = sourceStrategyId;
      if (sourcePersonaId) body.sourcePersonaId = sourcePersonaId;
      if (sourceRuleId) body.sourceRuleId = sourceRuleId;

      const response = await api.post('/admin/setup-wizard/sessions', body);
      const data = response.data;

      if (data.success && data.session) {
        setSessionId(data.session._id);
        setSessionStatus(data.session.status);
        setSessionMode(mode);
        setChangeLog(data.session.changeLog || []);
        setSourceName(data.sourceDescription || 'New Pipeline');
        setCurrentTaskIndex(0);
        setPhase('chat');

        // Add initial greeting from server
        const greeting = data.greeting || 'Welcome to the Setup Wizard. What would you like to configure?';
        setMessages([{ role: 'wizard', content: greeting }]);
      }
    } catch (err) {
      console.error('Error creating wizard session:', err);
      setError(err.response?.data?.msg || 'Failed to create wizard session');
    } finally {
      setIsCreatingSession(false);
    }
  };

  const handleSourceConfirm = () => {
    if (!selectedFlowId && !selectedStrategyId && !selectedPersonaId && !selectedRuleId) {
      setError('Please select at least one source configuration');
      return;
    }
    createSession(
      selectedMode,
      selectedFlowId || undefined,
      selectedStrategyId || undefined,
      selectedPersonaId || undefined,
      selectedRuleId || undefined
    );
  };

  const handleSendMessage = async () => {
    if (!inputValue.trim() || isLoading || !sessionId) return;

    const userMessage = inputValue.trim();
    setInputValue('');
    setError(null);

    setMessages(prev => [...prev, { role: 'admin', content: userMessage }]);

    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
    }

    try {
      setIsLoading(true);

      const response = await api.post(`/admin/setup-wizard/sessions/${sessionId}/messages`, {
        message: userMessage
      });
      const data = response.data;

      if (data.success && data.response) {
        setMessages(prev => [...prev, { role: 'wizard', content: data.response.text }]);

        if (data.sessionStatus) {
          setSessionStatus(data.sessionStatus);
        }
        if (data.sessionMode) {
          setSessionMode(data.sessionMode);
        }
        if (data.changeLog) {
          setChangeLog(data.changeLog);
        }

        if (data.response.hasConfig && data.response.config) {
          setDraftConfig(data.response.config);
          setValidationResults(null);
        }

        // Handle conversational task transitions
        if (data.taskTransition) {
          const transition = data.taskTransition;
          if (transition.transitioned) {
            // Auto-transition succeeded
            setSessionMode(transition.newMode);
            setSourceName(transition.sourceDescription || 'New Pipeline');
            setCurrentTaskIndex(transition.currentTaskIndex || 0);
            setSessionStatus('active');
            setDraftConfig(null);
            setValidationResults(null);
            setAppliedConfig(null);
            setInlineSourcePicker(null);

            // Add system boundary and greeting
            setMessages(prev => [
              ...prev,
              { role: 'system', content: `Switched to ${MODE_INFO[transition.newMode]?.title || transition.newMode} mode` },
              { role: 'wizard', content: transition.greeting }
            ]);
          } else if (transition.needsSourceSelection) {
            // Show inline source picker
            setInlineSourcePicker({
              mode: transition.suggestedMode,
              availableSources: transition.availableSources
            });
          }
        }
      }
    } catch (err) {
      console.error('Error sending message:', err);
      setError(err.response?.data?.msg || err.message || 'Failed to send message');
      setMessages(prev => [...prev, {
        role: 'wizard',
        content: 'I encountered an error processing your message. Please try again.'
      }]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleValidate = async () => {
    if (!sessionId || isValidating) return;

    try {
      setIsValidating(true);
      setError(null);

      const response = await api.get(`/admin/setup-wizard/sessions/${sessionId}/validate`);
      const data = response.data;

      if (data.success && data.validation) {
        setValidationResults(data.validation);
        if (data.sessionStatus) {
          setSessionStatus(data.sessionStatus);
        }
      }
    } catch (err) {
      console.error('Error validating config:', err);
      setError(err.response?.data?.msg || err.message || 'Failed to validate configuration');
    } finally {
      setIsValidating(false);
    }
  };

  const handleApply = async () => {
    if (!sessionId || isApplying) return;

    const actionWord = sessionMode === 'edit' ? 'update existing' : 'create';
    const confirmed = window.confirm(
      `This will ${actionWord} configuration documents in the database. Are you sure you want to proceed?`
    );

    if (!confirmed) return;

    try {
      setIsApplying(true);
      setError(null);

      const response = await api.post(`/admin/setup-wizard/sessions/${sessionId}/apply`);
      const data = response.data;

      if (data.success) {
        setAppliedConfig(data.appliedConfiguration || data.result?.createdIds || data.result?.updatedIds);
        setSessionStatus('applied');
        if (data.changeLog) {
          setChangeLog(data.changeLog);
        }
      }
    } catch (err) {
      console.error('Error applying config:', err);
      setError(err.response?.data?.msg || err.message || 'Failed to apply configuration');
    } finally {
      setIsApplying(false);
    }
  };

  const startNewTask = async (mode, sourceFlowId, sourceStrategyId, sourcePersonaId, sourceRuleId) => {
    try {
      setIsCreatingSession(true);
      setError(null);

      const body = { mode };
      if (sourceFlowId) body.sourceFlowId = sourceFlowId;
      if (sourceStrategyId) body.sourceStrategyId = sourceStrategyId;
      if (sourcePersonaId) body.sourcePersonaId = sourcePersonaId;
      if (sourceRuleId) body.sourceRuleId = sourceRuleId;

      const response = await api.post(`/admin/setup-wizard/sessions/${sessionId}/new-task`, body);
      const data = response.data;

      if (data.success) {
        setSessionStatus(data.sessionStatus);
        setSessionMode(mode);
        setTaskHistory(data.tasks || []);
        setChangeLog(data.changeLog || []);
        setSourceName(data.sourceDescription || 'New Pipeline');
        setCurrentTaskIndex(data.currentTaskIndex || 0);
        setDraftConfig(null);
        setValidationResults(null);
        setAppliedConfig(null);
        setInlineSourcePicker(null);
        setPhase('chat');

        // Add task boundary and new greeting
        setMessages(prev => [
          ...prev,
          { role: 'system', content: `Task completed. Starting new ${MODE_INFO[mode].title} task.` },
          { role: 'wizard', content: data.greeting || 'Ready for a new task. What would you like to do?' }
        ]);
      }
    } catch (err) {
      console.error('Error starting new task:', err);
      setError(err.response?.data?.msg || 'Failed to start new task');
    } finally {
      setIsCreatingSession(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleTextareaChange = (e) => {
    setInputValue(e.target.value);
    e.target.style.height = 'auto';
    e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
  };

  const canApply = sessionStatus === 'validated' ||
    (sessionStatus === 'draft_ready' && validationResults && validationResults.isValid);
  const isSessionApplied = sessionStatus === 'applied';
  const isSessionCancelled = sessionStatus === 'cancelled';

  // --- MODE SELECTOR SCREEN ---
  if (phase === 'mode_select') {
    return (
      <div style={styles.container}>
        <div style={{ ...styles.modeSelector, width: '100%' }}>
          <div style={styles.modeSelectorTitle}>Setup Wizard</div>
          <div style={styles.modeSelectorSubtitle}>
            Choose how you want to configure the platform
          </div>
          <div style={styles.modeCardsContainer}>
            {Object.entries(MODE_INFO).map(([mode, info]) => (
              <div
                key={mode}
                style={styles.modeCard}
                onClick={() => handleModeSelect(mode)}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = '#1a1a2e';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = '#e0e0e0';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={styles.modeCardTitle}>{info.title}</div>
                <div style={styles.modeCardDescription}>{info.description}</div>
              </div>
            ))}
          </div>
          {error && (
            <div style={{ color: '#c62828', fontSize: '13px', marginTop: '12px' }}>{error}</div>
          )}
        </div>
      </div>
    );
  }

  // --- SOURCE PICKER SCREEN ---
  if (phase === 'source_select') {
    const onConfirm = handleSourceConfirm;
    const onBack = () => {
      setPhase('mode_select');
      setError(null);
    };

    return (
      <div style={styles.container}>
        <div style={styles.sourcePickerContainer}>
          <div style={styles.sourcePickerTitle}>
            Select Source Configuration ({MODE_INFO[selectedMode]?.title})
          </div>
          <p style={{ fontSize: '13px', color: '#666', maxWidth: '500px', textAlign: 'center' }}>
            Choose the configuration you want to {selectedMode === 'clone' ? 'copy and modify' :
              selectedMode === 'edit' ? 'edit in place' : 'validate and troubleshoot'}.
            You can select a flow (which includes its linked triage and assignment), or individual components.
          </p>

          {isLoadingSources ? (
            <div style={{ color: '#666', fontSize: '14px' }}>Loading available configurations...</div>
          ) : availableSources ? (
            <div style={{ width: '100%', maxWidth: '500px' }}>
              {availableSources.flows?.length > 0 && (
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '4px' }}>
                    Onboarding Flow
                  </label>
                  <select
                    value={selectedFlowId}
                    onChange={e => setSelectedFlowId(e.target.value)}
                    style={styles.sourceSelect}
                  >
                    <option value="">-- Select a flow --</option>
                    {availableSources.flows.map(f => (
                      <option key={f._id} value={f._id}>
                        {f.name} ({f.slug}) - {f.stageCount} stages
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {availableSources.strategies?.length > 0 && (
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '4px' }}>
                    Triage Strategy (optional if flow selected)
                  </label>
                  <select
                    value={selectedStrategyId}
                    onChange={e => setSelectedStrategyId(e.target.value)}
                    style={styles.sourceSelect}
                  >
                    <option value="">-- Select a strategy --</option>
                    {availableSources.strategies.map(s => (
                      <option key={s._id} value={s._id}>
                        {s.name} ({s.key}) - {s.ruleCount} rules
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {availableSources.personas?.length > 0 && (
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '4px' }}>
                    Persona (optional)
                  </label>
                  <select
                    value={selectedPersonaId}
                    onChange={e => setSelectedPersonaId(e.target.value)}
                    style={styles.sourceSelect}
                  >
                    <option value="">-- Select a persona --</option>
                    {availableSources.personas.map(p => (
                      <option key={p._id} value={p._id}>
                        {p.name} ({p.key}) - {p.personaPurpose}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {availableSources.rules?.length > 0 && (
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '4px' }}>
                    Assignment Rule (optional if flow selected)
                  </label>
                  <select
                    value={selectedRuleId}
                    onChange={e => setSelectedRuleId(e.target.value)}
                    style={styles.sourceSelect}
                  >
                    <option value="">-- Select a rule --</option>
                    {availableSources.rules.map(r => (
                      <option key={r._id} value={r._id}>
                        {r.name} ({r.slug}) - {r.strategyType}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>
          ) : null}

          <div style={styles.sourcePickerActions}>
            <button onClick={onBack} style={styles.backButton}>Back</button>
            <button
              onClick={onConfirm}
              disabled={isCreatingSession || (!selectedFlowId && !selectedStrategyId && !selectedPersonaId && !selectedRuleId)}
              style={{
                ...styles.continueButton,
                ...(isCreatingSession || (!selectedFlowId && !selectedStrategyId && !selectedPersonaId && !selectedRuleId)
                  ? { opacity: 0.5, cursor: 'not-allowed' } : {})
              }}
            >
              {isCreatingSession ? 'Starting...' : 'Continue'}
            </button>
          </div>

          {error && (
            <div style={{ color: '#c62828', fontSize: '13px', marginTop: '12px' }}>{error}</div>
          )}
        </div>
      </div>
    );
  }

  // --- LOADING STATE ---
  if (isCreatingSession) {
    return (
      <div style={styles.container}>
        <div style={{ ...styles.emptyState, width: '100%' }}>
          <div style={styles.emptyStateIcon}>...</div>
          <div style={styles.emptyStateText}>Initializing Setup Wizard...</div>
        </div>
      </div>
    );
  }

  // --- MAIN CHAT INTERFACE ---
  return (
    <div style={styles.container}>
      {/* Left Panel - Chat */}
      <div style={styles.leftPanel}>
        <div style={styles.panelHeader}>
          <h3 style={styles.panelTitle}>
            Setup Wizard
            <span style={{ ...styles.statusBadge, ...getModeColor(sessionMode) }}>
              {MODE_INFO[sessionMode]?.title || sessionMode}
            </span>
            <span style={{ ...styles.statusBadge, ...getStatusStyle(sessionStatus) }}>
              {sessionStatus.replace('_', ' ')}
            </span>
          </h3>
          <p style={styles.panelSubtitle}>
            {sessionMode === 'create' && 'Describe your clinical needs and the wizard will generate a complete configuration'}
            {sessionMode === 'clone' && 'Describe the changes you want to make to the copied configuration'}
            {sessionMode === 'edit' && 'Describe what you want to change in the existing configuration'}
            {sessionMode === 'validate' && 'Review issues found and ask the wizard to fix them'}
          </p>
        </div>

        {/* Context Bar */}
        <div style={styles.contextBar}>
          <div style={{ ...styles.contextDot, backgroundColor: getModeDotColor(sessionMode) }} />
          <span style={{ ...styles.contextModeName, color: getModeDotColor(sessionMode) }}>
            {MODE_INFO[sessionMode]?.title || sessionMode}
          </span>
          <span style={styles.contextSeparator}>|</span>
          <span style={styles.contextSourceName}>{sourceName}</span>
          {currentTaskIndex > 0 && (
            <>
              <span style={styles.contextSeparator}>|</span>
              <span style={styles.contextTaskNumber}>T{currentTaskIndex + 1}</span>
            </>
          )}
        </div>

        <div style={styles.messagesContainer}>
          {messages.map((msg, index) => {
            if (msg.role === 'system') {
              return (
                <div key={index}>
                  <div style={styles.taskBoundary}>
                    <div style={styles.taskBoundaryLine} />
                    <span style={styles.taskBoundaryLabel}>{msg.content}</span>
                    <div style={styles.taskBoundaryLine} />
                  </div>
                </div>
              );
            }
            return (
              <div
                key={index}
                style={msg.role === 'admin' ? styles.messageBubbleAdmin : styles.messageBubbleWizard}
              >
                {msg.content}
              </div>
            );
          })}

          {isLoading && (
            <div style={styles.messageBubbleWizard}>
              <span style={styles.loadingDots}>Thinking...</span>
            </div>
          )}

          <div ref={messagesEndRef} />
        </div>

        {error && (
          <div style={{
            padding: '8px 20px',
            backgroundColor: '#ffebee',
            color: '#c62828',
            fontSize: '13px',
            borderTop: '1px solid #ef9a9a'
          }}>
            {error}
          </div>
        )}

        {isSessionApplied && !inlineSourcePicker && (
          <div style={styles.continuationHint}>
            Configuration applied successfully. You can continue chatting to start a new task.
          </div>
        )}

        {inlineSourcePicker && (
          <div style={styles.inlineSourcePicker}>
            <div style={styles.inlineSourcePickerHeader}>
              Switch to {MODE_INFO[inlineSourcePicker.mode]?.title || inlineSourcePicker.mode} mode — which configuration?
            </div>
            {inlineSourcePicker.availableSources?.flows?.length > 0 && (
              <select
                value={inlineSelectedFlowId}
                onChange={e => { setInlineSelectedFlowId(e.target.value); setInlineSelectedStrategyId(''); }}
                style={styles.inlineSourcePickerSelect}
              >
                <option value="">-- Select a flow --</option>
                {inlineSourcePicker.availableSources.flows.map(f => (
                  <option key={f._id} value={f._id}>{f.name} ({f.slug})</option>
                ))}
              </select>
            )}
            {inlineSourcePicker.availableSources?.strategies?.length > 0 && (
              <select
                value={inlineSelectedStrategyId}
                onChange={e => { setInlineSelectedStrategyId(e.target.value); setInlineSelectedFlowId(''); }}
                style={styles.inlineSourcePickerSelect}
              >
                <option value="">-- Or select a triage strategy --</option>
                {inlineSourcePicker.availableSources.strategies.map(s => (
                  <option key={s._id} value={s._id}>{s.name} ({s.key})</option>
                ))}
              </select>
            )}
            <div style={styles.inlineSourcePickerActions}>
              <button
                onClick={() => {
                  setInlineSourcePicker(null);
                  setInlineSelectedFlowId('');
                  setInlineSelectedStrategyId('');
                }}
                style={styles.backButton}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const mode = inlineSourcePicker.mode;
                  setInlineSourcePicker(null);
                  startNewTask(
                    mode,
                    inlineSelectedFlowId || undefined,
                    inlineSelectedStrategyId || undefined,
                    undefined,
                    undefined
                  );
                  setInlineSelectedFlowId('');
                  setInlineSelectedStrategyId('');
                }}
                disabled={!inlineSelectedFlowId && !inlineSelectedStrategyId}
                style={{
                  ...styles.continueButton,
                  ...(!inlineSelectedFlowId && !inlineSelectedStrategyId ? { opacity: 0.5, cursor: 'not-allowed' } : {})
                }}
              >
                Switch
              </button>
            </div>
          </div>
        )}

        {!isSessionCancelled && (
          <div style={styles.inputContainer}>
            <textarea
              ref={textareaRef}
              value={inputValue}
              onChange={handleTextareaChange}
              onKeyDown={handleKeyDown}
              placeholder={isSessionApplied ? "Type to start a new task..." : "Describe your requirements..."}
              style={styles.textInput}
              rows={1}
              disabled={isLoading}
            />
            <button
              onClick={handleSendMessage}
              disabled={isLoading || !inputValue.trim()}
              style={{
                ...styles.sendButton,
                ...(isLoading || !inputValue.trim() ? styles.sendButtonDisabled : {})
              }}
            >
              Send
            </button>
          </div>
        )}
      </div>

      {/* Right Panel - Tabs: Config / Change Log / Task History */}
      <div style={styles.rightPanel}>
        <div style={styles.panelHeader}>
          <h3 style={styles.panelTitle}>Details</h3>
        </div>

        <div style={styles.tabsContainer}>
          <button
            style={{ ...styles.tab, ...(activeTab === 'config' ? styles.tabActive : {}) }}
            onClick={() => setActiveTab('config')}
          >
            Configuration Preview
          </button>
          <button
            style={{ ...styles.tab, ...(activeTab === 'changelog' ? styles.tabActive : {}) }}
            onClick={() => setActiveTab('changelog')}
          >
            Change Log ({changeLog.length})
          </button>
          {taskHistory.length > 0 && (
            <button
              style={{ ...styles.tab, ...(activeTab === 'tasks' ? styles.tabActive : {}) }}
              onClick={() => setActiveTab('tasks')}
            >
              Task History ({taskHistory.length})
            </button>
          )}
        </div>

        {/* CONFIG TAB */}
        {activeTab === 'config' && (
          <>
            <div style={styles.configPreview}>
              {appliedConfig && (
                <div style={styles.appliedBanner}>
                  Configuration has been successfully {sessionMode === 'edit' ? 'updated' : 'applied'}. All documents have been {sessionMode === 'edit' ? 'updated in' : 'created in'} the database.
                </div>
              )}

              {validationResults && (
                <div>
                  {validationResults.isValid && (
                    <div style={{ ...styles.validationResults, ...styles.validationSuccess }}>
                      <p style={{ ...styles.validationTitle, color: '#2e7d32' }}>Validation Passed</p>
                      <p style={styles.validationItem}>All checks passed. Configuration is ready to apply.</p>
                    </div>
                  )}
                  {validationResults.errors && validationResults.errors.length > 0 && (
                    <div style={{ ...styles.validationResults, ...styles.validationError }}>
                      <p style={{ ...styles.validationTitle, color: '#c62828' }}>
                        Errors ({validationResults.errors.length})
                      </p>
                      {validationResults.errors.map((err, i) => (
                        <p key={i} style={{ ...styles.validationItem, color: '#b71c1c' }}>- {err}</p>
                      ))}
                    </div>
                  )}
                  {validationResults.warnings && validationResults.warnings.length > 0 && (
                    <div style={{ ...styles.validationResults, ...styles.validationWarning }}>
                      <p style={{ ...styles.validationTitle, color: '#e65100' }}>
                        Warnings ({validationResults.warnings.length})
                      </p>
                      {validationResults.warnings.map((warn, i) => (
                        <p key={i} style={{ ...styles.validationItem, color: '#bf360c' }}>- {warn}</p>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {draftConfig ? (
                <div>
                  {draftConfig.persona && (
                    <div style={styles.configSection}>
                      <h4 style={styles.configSectionTitle}>Therapist Persona</h4>
                      <pre style={styles.configCode}>
                        {JSON.stringify(draftConfig.persona, null, 2)}
                      </pre>
                    </div>
                  )}
                  {draftConfig.onboardingFlow && (
                    <div style={styles.configSection}>
                      <h4 style={styles.configSectionTitle}>Onboarding Flow</h4>
                      <pre style={styles.configCode}>
                        {JSON.stringify(draftConfig.onboardingFlow, null, 2)}
                      </pre>
                    </div>
                  )}
                  {draftConfig.triageStrategy && (
                    <div style={styles.configSection}>
                      <h4 style={styles.configSectionTitle}>Triage Strategy</h4>
                      <pre style={styles.configCode}>
                        {JSON.stringify(draftConfig.triageStrategy, null, 2)}
                      </pre>
                    </div>
                  )}
                  {draftConfig.assignmentRule && (
                    <div style={styles.configSection}>
                      <h4 style={styles.configSectionTitle}>Assignment Rule</h4>
                      <pre style={styles.configCode}>
                        {JSON.stringify(draftConfig.assignmentRule, null, 2)}
                      </pre>
                    </div>
                  )}
                  {draftConfig.reasoning && (
                    <div style={styles.configSection}>
                      <h4 style={styles.configSectionTitle}>Reasoning</h4>
                      <p style={{ margin: 0, fontSize: '13px', lineHeight: '1.5', color: '#555', whiteSpace: 'pre-wrap' }}>
                        {draftConfig.reasoning}
                      </p>
                    </div>
                  )}
                </div>
              ) : (
                <div style={styles.emptyState}>
                  <div style={styles.emptyStateIcon}>&#9881;</div>
                  <div style={styles.emptyStateText}>
                    No configuration generated yet.<br />
                    Chat with the wizard to describe your requirements and<br />
                    it will generate a complete pipeline configuration.
                  </div>
                </div>
              )}
            </div>

            {draftConfig && !isSessionApplied && !isSessionCancelled && (
              <div style={styles.actionButtonsContainer}>
                <button
                  onClick={handleValidate}
                  disabled={isValidating}
                  style={{
                    ...styles.validateButton,
                    ...(isValidating ? { opacity: 0.5, cursor: 'not-allowed' } : {})
                  }}
                >
                  {isValidating ? 'Validating...' : 'Validate Configuration'}
                </button>
                <button
                  onClick={handleApply}
                  disabled={!canApply || isApplying}
                  style={{
                    ...styles.applyButton,
                    ...(!canApply || isApplying ? styles.applyButtonDisabled : {})
                  }}
                >
                  {isApplying ? 'Applying...' : (sessionMode === 'edit' ? 'Apply Changes' : 'Apply Configuration')}
                </button>
              </div>
            )}
          </>
        )}

        {/* CHANGE LOG TAB */}
        {activeTab === 'changelog' && (
          <div style={styles.configPreview}>
            {changeLog.length === 0 ? (
              <div style={styles.emptyState}>
                <div style={styles.emptyStateText}>No changes recorded yet.</div>
              </div>
            ) : (
              [...changeLog].reverse().map((entry, index) => (
                <div key={index} style={styles.changeLogEntry}>
                  <div style={styles.changeLogAction}>
                    {entry.action.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                    {entry.taskIndex !== undefined && (
                      <span style={{ fontSize: '11px', color: '#999', fontWeight: 400, marginLeft: '8px' }}>
                        Task {entry.taskIndex + 1}
                      </span>
                    )}
                  </div>
                  <div style={styles.changeLogSummary}>{entry.summary}</div>
                  <div style={styles.changeLogTime}>
                    {new Date(entry.timestamp).toLocaleString()}
                  </div>
                  {(entry.before || entry.after) && (
                    <div
                      style={{ marginTop: '6px', cursor: 'pointer', fontSize: '11px', color: '#1565c0' }}
                      onClick={(e) => {
                        const diffEl = e.currentTarget.nextSibling;
                        if (diffEl) diffEl.style.display = diffEl.style.display === 'none' ? 'block' : 'none';
                      }}
                    >
                      Show diff
                    </div>
                  )}
                  {(entry.before || entry.after) && (
                    <div style={{ ...styles.changeLogDiff, display: 'none' }}>
                      {entry.before && (
                        <div>
                          <strong style={{ color: '#c62828' }}>Before:</strong>
                          <pre style={{ margin: '4px 0' }}>{JSON.stringify(entry.before, null, 2)}</pre>
                        </div>
                      )}
                      {entry.after && (
                        <div>
                          <strong style={{ color: '#2e7d32' }}>After:</strong>
                          <pre style={{ margin: '4px 0' }}>{JSON.stringify(entry.after, null, 2)}</pre>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        )}

        {/* TASK HISTORY TAB */}
        {activeTab === 'tasks' && (
          <div style={styles.configPreview}>
            {taskHistory.length === 0 ? (
              <div style={styles.emptyState}>
                <div style={styles.emptyStateText}>No completed tasks yet.</div>
              </div>
            ) : (
              taskHistory.map((task, index) => (
                <div
                  key={index}
                  style={styles.taskHistoryItem}
                  onClick={() => setExpandedTask(expandedTask === index ? null : index)}
                >
                  <div style={styles.taskHistoryHeader}>
                    <div>
                      <span style={{ ...styles.taskHistoryMode, ...getModeColor(task.mode) }}>
                        {task.mode}
                      </span>
                      <span style={{ fontSize: '14px', fontWeight: 500, color: '#333', marginLeft: '8px' }}>
                        Task {task.taskIndex + 1}
                      </span>
                    </div>
                    <span style={{
                      fontSize: '11px',
                      color: task.status === 'completed' ? '#2e7d32' : '#999',
                      fontWeight: 600
                    }}>
                      {task.status}
                    </span>
                  </div>
                  <div style={{ fontSize: '13px', color: '#555' }}>{task.summary}</div>
                  <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                    {task.completedAt ? new Date(task.completedAt).toLocaleString() : ''}
                  </div>

                  {expandedTask === index && (
                    <div style={{ marginTop: '12px', borderTop: '1px solid #eee', paddingTop: '12px' }}>
                      {task.messages && task.messages.length > 0 && (
                        <div>
                          <div style={{ fontSize: '12px', fontWeight: 600, color: '#333', marginBottom: '8px' }}>
                            Conversation ({task.messages.length} messages)
                          </div>
                          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            {task.messages.map((msg, mi) => (
                              <div key={mi} style={{
                                padding: '6px 10px',
                                marginBottom: '4px',
                                borderRadius: '6px',
                                backgroundColor: msg.role === 'admin' ? '#f0f4f8' : '#fafafa',
                                fontSize: '12px',
                                lineHeight: '1.4'
                              }}>
                                <strong>{msg.role}:</strong> {msg.content.substring(0, 200)}
                                {msg.content.length > 200 ? '...' : ''}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {task.draftConfiguration && (
                        <div style={{ marginTop: '8px' }}>
                          <div style={{ fontSize: '12px', fontWeight: 600, color: '#333', marginBottom: '4px' }}>
                            Final Configuration
                          </div>
                          <pre style={{ ...styles.configCode, fontSize: '11px', maxHeight: '200px' }}>
                            {JSON.stringify(task.draftConfiguration, null, 2)}
                          </pre>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default SetupWizard;
